(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brm-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function (event) {
    var range = event.target;
    if (!range.classList || !range.classList.contains('brm-compare__range')) return;
    var stage = range.closest('[data-brm-compare]');
    if (stage) stage.style.setProperty('--brm-compare-pos', range.value + '%');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brm-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-brm-countdown]');
    if (!bars.length) return;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var now = Math.floor(Date.now() / 1000);
      bars.forEach(function (bar) {
        var left = parseInt(bar.getAttribute('data-brm-countdown'), 10) - now;
        if (!(left > 0)) { bar.hidden = true; return; }
        bar.querySelector('[data-brm-days]').textContent = pad(Math.floor(left / 86400));
        bar.querySelector('[data-brm-hours]').textContent = pad(Math.floor((left % 86400) / 3600));
        bar.querySelector('[data-brm-minutes]').textContent = pad(Math.floor((left % 3600) / 60));
        bar.querySelector('[data-brm-seconds]').textContent = pad(left % 60);
      });
    }
    tick();
    window.setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brm-parallax-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var heroes = document.querySelectorAll('[data-brm-parallax]');
    if (!heroes.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var layer = hero.querySelector('[data-brm-parallax-layer]');
        if (layer) layer.style.transform = 'translate3d(0,' + Math.round(rect.top * -0.12) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
